import MySchedule from '@educator/Container/MySchedule/MySchedule';
import { setSelectedNav } from '@actions/educator';

const EducatorScheduleLandingPage = () => <MySchedule />;

EducatorScheduleLandingPage.getInitialProps = async ({ store }) => {
  store.dispatch(setSelectedNav('eduSchedule'));
  return {};
};

EducatorScheduleLandingPage.pageInfo = {
  layoutOptions: {
    showEducatorNav: true
  }
};

export default EducatorScheduleLandingPage;

EducatorScheduleLandingPage.getInitialProps = async ({ store, isServer }) => {
  store.dispatch(setSelectedNav('eduSchedule'));
  return { isServer };
};
